import React, {Suspense} from 'react';
import {Route, Switch} from "react-router";
import {Routes} from "../constants/Routes";
import AppWrapper from "../components/app/AppWrapper";
import {IntegrationsListing} from "../components/integrations/IntegrationsListing";
import {IntegrationCreate} from "../components/integrations/IntegrationCreate";
import {IntegrationEditorRoot} from "../components/integrations/IntegrationEditorRoot";
import {Loader} from "../components/ui/Loader";
import {CreateConnection} from "../components/connections/CreateConnection";


export function AppRootContainer() {

    return (
        <Suspense
            fallback={() => (
                <div className="pre-loader">
                    <Loader />
                </div>
            )}
        >
            <AppWrapper>
                <Switch>
                    <Route path={Routes.IntegrationList} exact={true} component={IntegrationsListing}/>
                    <Route path={Routes.IntegrationCreate} exact={true} component={IntegrationCreate}/>
                    <Route path={Routes.IntegrationEditor}  component={IntegrationEditorRoot}/>
                    <Route path={Routes.ConnectionCreate} exact={true} component={CreateConnection}/>
                </Switch>
            </AppWrapper>
        </Suspense>
    );
}

